module.exports = __webpack_public_path__ + "img/arrow_full_right_white.061f2690.svg";